type ProgressBarProps = {
  currentStep: number;
};

const labels = ["活動廣告", "會員註冊", "輪盤", "聯絡客服"];

export function ProgressBar({ currentStep }: ProgressBarProps) {
  return (
    <nav className="progress" aria-label="活動進度">
      {labels.map((label, index) => (
        <div className={`progress-item ${index <= currentStep ? "is-active" : ""}`} key={label}>
          <span>{index + 1}</span>
          <small>{label}</small>
        </div>
      ))}
    </nav>
  );
}
